import script from "./bindUser.vue?vue&type=script&setup=true&lang=js"
export * from "./bindUser.vue?vue&type=script&setup=true&lang=js"

import "./bindUser.vue?vue&type=style&index=0&id=94c71664&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94c71664"]])

export default __exports__